import type {ReactNode} from 'react';
import {Box, Flex, Paper, Text, ThemeIcon} from '@mantine/core';

/**
 * Non-interactive metric tile — shares `StatCard`'s visual anatomy (bordered
 * `Paper`, uppercase dimmed label, bold value, right-aligned `ThemeIcon`)
 * without the click/active/filter behavior.
 * @registry Read-only metric tile (title/value/icon), no click/active state.
 *
 * Use for read-only stat displays; use `StatCard` when the tile is
 * clickable/filterable.
 */
export interface StatTileProps {
  title: string;
  value: ReactNode;
  icon: ReactNode;
  iconColor?: string;
}

export const StatTile = ({
  title,
  value,
  icon,
  iconColor = 'gray',
}: StatTileProps) => {
  return (
    <Paper p="md" withBorder shadow="xs">
      <Flex justify="space-between" align="flex-start">
        <Box>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            {title}
          </Text>
          <Text size="xl" fw={700} mt={4}>
            {value}
          </Text>
        </Box>
        <ThemeIcon size="lg" variant="light" color={iconColor}>
          {icon}
        </ThemeIcon>
      </Flex>
    </Paper>
  );
};
